module.exports = __webpack_public_path__ + "static/media/betamax.8f08c001.svg";